import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * BEC MAC Validator
 * 
 * @returns {ValidatorFn}
 */
export function becMacValidator(): ValidatorFn {
    const macFormat = /^(0004ED[0-9A-F]{6}|600347[0-9A-F]{6}|[0-9]{15})(,(0004ED[0-9A-F]{6}|600347[0-9A-F]{6}|[0-9]{15}))*$/;
    return (control: AbstractControl): ValidationErrors | null => {
        const upperCaseValue = control.value.toUpperCase();
        return macFormat.test(upperCaseValue) ? null : { becMacFormat: true };
    };
}